import {
	Box,
	Container,
	Divider,
	LinearProgress,
	makeStyles,
	Typography
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import { useActions, useValues } from 'kea';

import profilelogic from 'src/store/profile';
import grouplogic from 'src/store/group';
import vehiclelogic from 'src/store/vehicle';
import geofencelogic from 'src/store/geofence';

import Page from 'src/components/Page';
import checkRole from '../../utils/checkRole';
import IncludedResult from './Included/Results';
import Toolbar from './Toolbar';

//TODO clean styles
const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3)
	},
	card: {

	}
}));


let included_columns = [
	{
		field: 'enabled',
		headerName: 'Enabled',
		align: 'left',
		width: 50,
	},
	{
		field: 'type',
		headerName: 'Type',
		align: 'left',
		width: 70,
	},
	{
		field: 'name',
		headerName: 'Name',
		align: 'left',
		width: 200
	},
	{
		field: 'registration',
		headerName: 'Registration',
		align: 'left',
		width: 200
	},
	{
		field: 'actions',
		align: 'right',
		headerName: 'Actions',
		width: 100,
	},
];


const GeofenceView = () => {

	const classes = useStyles();
	const { profile } = useValues(profilelogic);

	const { geofences } = useValues(geofencelogic);
	const { fetchAll: geofenceFetchAll } = useActions(geofencelogic);

	const { vehicles } = useValues(vehiclelogic);
	const { fetchAll: vehicleFetchAll } = useActions(vehiclelogic);

	const [selectedGeofence, setSelectedGeofence] = useState(null);

	useEffect(() => {
		geofences ?? geofenceFetchAll();
		vehicles ?? vehicleFetchAll();
	}, []) // eslint-disable-line

	const handle_select_filter = (index) => {
		setSelectedGeofence(geofences[index] || null);
	}

	if (!checkRole(profile, ['GeofenceEdit'])) {
		included_columns = included_columns.filter((item) => {
			return item.field !== 'actions';
		});
	}

	if (geofences === null || vehicles === null) {
		return (
			<></>
		)
	}

	return (
		<Page
			className={classes.root}
			title="Geofence"
		>
			<Container maxWidth={false}>
				<Box mt={3} >
					<Typography variant="h3" gutterBottom>
						Geofence
					</Typography>
					<Divider />
				</Box>
				<Toolbar select_filter={handle_select_filter} selectedGeofence={selectedGeofence} rows={geofences} />
				<Box mt={3}>
					<Grid container spacing={1}>
						<Grid item lg={12} xs={12} sm={12} md={12} >
							{
								selectedGeofence ?
									<IncludedResult selectedGeofence={selectedGeofence} columns={included_columns} />
									:
									null
							}
						</Grid>
					</Grid>
				</Box>
			</Container>
		</Page>
	);
};

export default GeofenceView;
